import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Chip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function getRoleLabel(role) {
  switch (role) {
    case 'ROLE_ADMIN':
      return { label: 'Administrateur', color: 'error' };
    case 'ROLE_HOTESS':
      return { label: 'Hôtesse', color: 'primary' };
    case 'ROLE_SELLER':
      return { label: 'Caissier', color: 'success' };
    default:
      return { label: role, color: 'default' };
  }
}

const Show = ({ open, onClose, userData }) => {
  if (!userData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{
        m: 0,
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #e0e0e0'
      }}>
        <Typography variant="h6">
          Détails de l'utilisateur
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Nom
          </Typography>
          <Typography variant="body1" gutterBottom>
            {userData.name}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Email
          </Typography>
          <Typography variant="body1" gutterBottom>
            {userData.email}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Rôles
          </Typography>
          <Box sx={{ mt: 1 }}>
            {userData.roles.map(role => {
              const { label, color } = getRoleLabel(role);
              return (
                <Chip
                  key={role}
                  label={label}
                  color={color}
                  size="small"
                  sx={{ mr: 1, mb: 1 }}
                />
              );
            })}
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: '#333'
            }
          }}
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

Show.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
    pin: PropTypes.string
  })
};

export default Show; 